import { Node, Range, Transforms } from 'slate';
import updateAnnotationHOF from 'components/text-editor/hooks/use-custom-editor/actions/update-annotation';
import createAnnotationHOF from 'components/text-editor/hooks/use-custom-editor/actions/create-annotation';
import { merge } from 'lodash/fp';
import { AnyObject } from 'types';
import { CustomEditor } from 'components/text-editor/hooks/use-custom-editor/index';

export type SaveAnnotation = (
  selection: Range | undefined | null,
  customData: AnyObject,
) => AnyObject;

interface Options {
  at?: any;
  mode?: string;
  match?: (node: Node) => boolean;
}

export default function saveAnnotation(editor: CustomEditor) {
  const createAnnotation = createAnnotationHOF(editor);
  const updateAnnotation = updateAnnotationHOF(editor);

  return function (selection: Range | undefined | null, customData: any) {
    if (customData.annotationId) {
      const node = editor.getSelectedNode();

      const at = editor.getSlateRangeByAnnotationId(customData.annotationId);

      at && Transforms.select(editor, at);

      updateAnnotation(customData, { at });

      //Transforms.deselect(editor);

      return merge(node, customData);
    } else {
      const at = selection || editor.selection;

      at && Transforms.select(editor, at);
      const data = createAnnotation(customData, { at });
      Transforms.deselect(editor);
      return data;
    }
  };
}
